import React, { useState } from 'react';
import Header from '../navigation/Header';
import GlobalControlsBar from '../navigation/GlobalControlsBar';

const MainLayout = ({ children, showControls = true }) => {
  const [globalFilters, setGlobalFilters] = useState({
    dateRange: '7d',
    currency: 'usd',
    isRealTime: true
  });

  const handleFiltersChange = (filters) => {
    setGlobalFilters(prev => ({ ...prev, ...filters }));
    console.log('Global filters updated:', filters);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {showControls && (
        <GlobalControlsBar onFiltersChange={handleFiltersChange} />
      )}

      <main className={showControls ? 'main-content with-controls' : 'main-content'}>
        {children}
      </main>
    </div>
  );
};

export default MainLayout;